import { Chip, TextField } from "@mui/material";
import { Box } from "@mui/system";
import MultipleSelect from "../MultipleSelect";
import SelectMenu from "../SelectMenu";
import TableFilterAcionts from "../TableFilterAcionts";


interface IProps {
  filter: IFilter;
  setFilter: (filter: IFilter) => void;
  handleSearch: (filter?: IFilter) => void;
}

interface IFilter {
  status: boolean;
  data: {
    name: string;
    status: string;
  };
}
const initFilterData: IFilter = {
  status: true,
  data: {
    name: "",
    status: "",
  },
};

export default function FilterForm({
  filter,
  setFilter,
  handleSearch,
}: IProps) {
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({
      ...filter,
      data: {
        ...filter.data,
        [event.target.name]: event.target.value,
      },
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
        <TextField
          label="Role Name"
          variant="standard"
          value={filter.data.name}
          name="name"
          onChange={handleChanges}
          sx={{ flex: "1 1 40%" }}
        />
        <SelectMenu
          label="Status"
          handleChange={({ target }) => {
            setFilter({
              ...filter,
              data: {
                ...filter.data,
                status: target.value,
              },
            });
          }}
          options={[
            { value: "", label: "Status" },
            { value: "active", label: "Active" },
            { value: "inActive", label: "InActive" },
          ]}
          value={filter.data.status}
          sx={{ flex: "1 1 40%" }}
        />
      </Box>
      <TableFilterAcionts
        disableCancel={
          filter.data.name === "" && filter.data.status === ""
        }
        handleClearSearch={() => {
          setFilter(initFilterData);

          handleSearch(initFilterData);
        }}
        handleSearch={handleSearch}
      />
    </Box>
  );
}
